import { createComponentExtension, createPlugin } from '@backstage/core-plugin-api'

import { rootRouteRef } from './routes'

export const announcementsPlugin = createPlugin({
  id: 'announcements',
  routes: {
    root: rootRouteRef
  }
})

export const HomeAnnouncementBanner = announcementsPlugin.provide(
  createComponentExtension({
    name: 'HomeAnnouncementBanner',
    component: {
      lazy: () =>
        import('./components/HomeAnnouncementBanner').then(m => m.HomeAnnouncementBanner)
    }
  })
)

export const TopAnnouncementBanner = announcementsPlugin.provide(
  createComponentExtension({
    name: 'TopAnnouncementBanner',
    component: {
      lazy: () =>
        import('./components/TopAnnouncementBanner').then(m => m.TopAnnouncementBanner)
    }
  })
)
